// Normalizações usadas na deduplicação (URL) e na unicidade de etiquetas. Spec §7.5 etapa 1 e §6.3 (tags.normalized).

const TRACKING = /^(utm_.*|fbclid|gclid)$/i;

/** URL salva → forma canônica (host minúsculo, sem rastreadores nem #fragmento) e domínio de origem. null se não for http/https. */
export function normalizeUrl(raw: string): { canonical: string; domain: string } | null {
  let u: URL;
  try {
    u = new URL(raw.trim());
  } catch {
    return null;
  }
  if (u.protocol !== "http:" && u.protocol !== "https:") return null;
  u.hash = "";
  // Tira só os pares de rastreio; os outros ficam byte a byte (URLSearchParams.toString reescreveria , / : %20).
  u.search = u.search
    .slice(1)
    .split("&")
    .filter((pair) => !TRACKING.test(new URLSearchParams(pair).keys().next().value ?? ""))
    .join("&");
  return { canonical: u.href, domain: u.hostname.replace(/^www\./, "") };
}

/** Chave de unicidade da etiqueta: minúsculas, sem acento, espaços colapsados. O nome exibido fica como digitado. */
export function normalizeTag(name: string): string {
  return name.normalize("NFD").replace(/\p{M}/gu, "").toLowerCase().trim().replace(/\s+/g, " ");
}
